import { FC } from "react";
import CPanelPage from "@web-src/modules/workspace/pages/CPanelPage";
import { CXWorkspaceSettingsLayout } from "../CXWorkspaceSettingsLayout";

export const CXWorkspaceTeamPage: FC = () => (
  <CXWorkspaceSettingsLayout>
    <CPanelPage useDefaultLayout={false} />
  </CXWorkspaceSettingsLayout>
);
